import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 've-administration',
  templateUrl: './administration.component.html',
})
export class AdministrationComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit() {
    //this is kept empty on purpose
  }
  back = () => this.router.navigate(['/VE']);

}
